<button 
  class="button-undecorated order-details-button" 
  [ngClass]="{
    'selected': hasOrderType(),
    'order-details-cart': isInCart(),
    'store-info-style': storeInfoStyle()
  }"
  (click)="toggleOrderDetails()"
>
    <cwo-icon [name]="storeInfoStyle() ? iconName.store : iconName.location" class="icon" aria-hidden="true" />
    <span class="btn-label">{{orderDetailsButtonLabel()}}</span>

    @if (!isSelfOrder() && !storeInfoStyle()) {
        @if (isInCart()){
            <cwo-icon [name]="iconName.edit" class="icon circled" />
        } @else {
            <cwo-icon [name]="iconName.arrow" class="icon" />
        }
    }
</button>